module.exports = __webpack_public_path__ + "static/es-cover-d27e8be9c94b6b3413fff17117c26fc0.jpg";